import { Box, OSKThemeType, Text } from 'oskcomponents';
import { OSKIcon, OSKIconType } from 'oskcomponents/src/OSKIcon/OSKIcon';
import { hasParentWithId, Geometry, noop, OSKGeoJson } from 'oskcore';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useTheme } from 'styled-components';
import { AssetDetection } from '~/redux/modules/monitor/app';
import { RootState } from '~/redux/store';
import { coord_format } from '~/utils';
import { OSKMapTooltip } from '../../../molecules/map/OSKMapTooltip';

type AlertMarkerProps = {
    /* Whether to render this marker or not */
    visible?: boolean;
    /** Coordinates for placing this on the map */
    position: OSKGeoJson;
    /** The id of the asset */
    assetId: string;
    /** The id of the alert */
    alertId: string;
    /** The alert object */
    alert: AssetDetection;
};

const AlertMarker = ({ visible, position, alert }: AlertMarkerProps) => {
    const theme = useTheme() as OSKThemeType;
    // TODO: Replace data.message with new alert type prop
    const iconCodeMap: Record<string, OSKIconType> = {
        'Soil Contamination': 'hydrocarbon',
        Plume: 'methane',
        'Hydrocarbon Leak': 'hydrocarbon',
    };
    const coords = (alert.coordinates as Geometry).coordinates;
    const coordText = `${coords[1]}, ${coords[0]}`;
    const visualCoordText = coord_format(coords);
    const [coordMessage, setCoordMessage] = useState(visualCoordText);

    const copyCoords = (evt: any) => {
        const isCopyButton = hasParentWithId(evt.originalEvent.target, 'copy-button');

        if (isCopyButton) {
            navigator.clipboard.writeText(coordText);
            setCoordMessage('Copied');
            setTimeout(() => {
                setCoordMessage(visualCoordText);
            }, 3000);
        }
    };

    return visible ? (
        <OSKMapTooltip position={position} onClick={(evt) => copyCoords(evt)}>
            <Box grow row center="all">
                <OSKIcon
                    code={iconCodeMap[alert.detection_type] ?? 'alert-circle'}
                    fill="red"
                    width={50}
                    height={50}
                    style={{ paddingRight: '12px' }}
                />
                <Box col h={60} style={{ justifyContent: 'space-between' }}>
                    <Text strong>{alert.detection_type}</Text>
                    <Text variant="small">{alert.call_type}</Text>
                    <Box row center="vertical" id="copy-button">
                        <Text variant="small" w={100} style={{ textDecoration: 'underline' }}>
                            {coordMessage}
                        </Text>
                        <OSKIcon code="copy" style={{ paddingLeft: '8px' }} />
                    </Box>
                </Box>
            </Box>
        </OSKMapTooltip>
    ) : (
        <React.Fragment />
    );
};

export { AlertMarker };
export type { AlertMarkerProps };

const mapStateToProps = (state: RootState, ownProps: Partial<AlertMarkerProps>) => {
    const visibleAlerts = state.monitor.app.visibleDetections;
    const assetId = ownProps.assetId + '';
    const alertId = ownProps.alertId + '';

    let visible = false;

    if (visibleAlerts[alertId]) {
        visible = true;
    }

    return {
        visible: visible,
    };
};
export default connect(mapStateToProps, noop)(AlertMarker);
